module.exports = __webpack_public_path__ + "img/Intro_text04_avatars_v1.71ba9623.png";